export class Comparator {
  static compare(a: number | boolean | string | Date, b: number | boolean | string | Date, isAscending: boolean = true): number {
    if (!isAscending) {
      return this.compare(b, a, true);
    }
    if ((a === undefined) || (b === undefined)) {
      throw new Error("引数にundefinedが指定されています.");
    } else if ((a === null) || (b === null)) {
      throw new Error("引数にnullが指定されています.");
    } else if ((typeof(a) === "number") && (typeof(b) === "number")) {
      return this.compareNumber(a, b);
    } else if ((typeof(a) === "string") && (typeof(b) === "string")) {
      return this.compareString(a, b);
    } else if ((typeof(a) === "boolean") && (typeof(b) === "boolean")) {
      return this.compareBoolean(a, b);
    } else if ((a instanceof Date) && (b instanceof Date)) {
      return this.compareDate(a, b);
    } else {
      throw new Error("引数の型が一致していません.");
    }
  }

  private static compareNumber(a: number, b: number): number {
    return a - b;
  }

  private static compareBoolean(a: boolean, b: boolean): number {
    if (a < b) { return -1; }
    if (a > b) { return 1; }
    return 0;
  }

  private static compareString(a: string, b: string): number {
    a = a || "";
    b = b || "";

    if (a < b) { return -1; }
    if (a > b) { return 1; }
    return 0;
  }

  private static compareDate(a: Date, b: Date): number {
    if (a < b) { return -1; }
    if (a > b) { return 1; }
    return 0;
  }
}
